export default __webpack_public_path__ + "static/media/settings.f1abf606.svg";